
// src/reducers/index.js
import { combineReducers } from 'redux';
import { APP_LOGOUT } from '../constants/actionTypes';

import searchResults from './searchResults';
import autocomplete  from './autocomplete';
import sideEffects   from './sideEffects';
import user          from './user';
import inventory from './inventory';
import notifications from './notifications';
import dashboard     from './dashboard';
import sales         from './sales';
import ui            from './ui';
import access from './access';

// Build the full tree ONCE
const appReducer = combineReducers({
  user,
  autocomplete,
  searchResults,
  sideEffects,
  inventory,
  notifications,
  dashboard,
  sales,
  ui,
  access
});

// Capture initial state for clean resets
const initialState = appReducer(undefined, { type: '@@INIT' });

// Root reducer that resets everything on logout
const rootReducer = (state, action) => {
  if (action.type === APP_LOGOUT) {
    return initialState;
  }
  return appReducer(state, action);
};

// --- Named export for compatibility with: import { reducers } from './reducers'
export const reducers = rootReducer;

// --- Default export (recommended long-term)
export default rootReducer;
